<template>
  <v-dialog
    v-model="opened"
    width="60vw"
  >
      <v-img
        contain
        max-width="60vw"
        :src="url"
      >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-10 grey"
          align="center"
          justify="center"
        >
          <v-progress-circular indeterminate color="primary" />
        </v-row>
      </template>
        
      <div class="d-flex justify-end mt-2 mr-2">
        <v-btn 
          x-large
          color="primary"
          icon
          @click="closeModal"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
        
      </v-img>
  </v-dialog>
</template>

<script>
export default {
  name: "ShowPhotoModal",
  data() {
    return {
      opened: false,
      url: null,
    }
  },
  methods: {
    closeModal() {
      this.opened = false
      this.url = null
    },
    openModal(url) {
      this.url = url
      this.opened = true
    }
  }
}
</script>

<style>
.outlined {
  border: 10px solid #009DD9;
}
</style>
